import React from 'react'
import Divider from 'material-ui/Divider'
import Drawer from 'material-ui/Drawer'
import { Link } from 'react-router'
import MenuItem from 'material-ui/MenuItem'

import items from '../../configs/section-config'

const NavDrawer = ({browser, onClose, onRequestChange, open}) => {
    const menuItems = Object.keys(items).filter(item => !items[item].omitInTabs).map((item, index) =>{
    const {title, path} = items[item];

    return (
      <div className="drawer-item" key={index}>
      <Link
        to={path}
        activeClassName='active'
        onClick={onClose.bind(null, path)}
      >
        <MenuItem>
          <span>{title}</span>
        </MenuItem>
      </Link>
      <Divider />
      </div>
      )
  })

  menuItems.unshift(
    <div className="drawer-item" key="Close" onClick={()=> onClose()}>
      <MenuItem style={{padding: "16px 0px 0px 0px"}}>
        <span className="x">x</span>
      </MenuItem>
      <Divider />
    </div>
  )

  return (
    <Drawer
      containerClassName="nav-drawer"
      docked={false}
      open={open}
      onRequestChange={(open) => onRequestChange(open)}
      style={{width: '75%'}}>
      {menuItems}
    </Drawer>
  )
}

export default NavDrawer



// WEBPACK FOOTER //
// ./src/components/NavBar/NavDrawer.js